import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import { vignettePreview_template } from "./vignettePreview_template";
import { vignettePreview_helper } from "../../modules/vignettePreview_helper";

declare var ko: any;

export class vignettesEdit_template extends vnTemplate {
    protected vignettePreview: vignettePreview_template;
    protected vignettePreviewHelper: vignettePreview_helper;
    protected stylesheetSelector: multipleSelector_template;
    protected monacoEditors: any = {};
    protected monacoLoaderPromise: any = null;
    protected availableStylesheets: any[] = [];
    protected selectedStylesheetDetails: any[] = [];

    protected getTemplateHtml(): string {
        return /*html*/ `
            <div class="w-form w-form-large">
                <div class="form-header">
                    <h3 class="form-title icon i-summary" data-bind="vtext: name">Vignette Editor</h3>
                    <div style="margin-left: auto; margin-right: 10px;" data-bind="visible: showIsAutosaving">Autosaving...</div>

                    <button type="button"  data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2"></button>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">Name</label>
                            <div class="w-input">
                                <input type="text" name="name" id="name"  class="input-text" data-bind="value: name">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Status</label>
                            <div class="w-input">
                                <select class="input-select" data-bind="value: idStatus">
                                    <option value="1">Draft</option>
                                    <option value="2">Completed</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Shared Stylesheets</label>
                            <p class="form-text">Optional. Select one or more shared stylesheets in addition to this vignette's own CSS.</p>
                            ${this.stylesheetSelector.getHtmlBuild()}
                            <div class="w-filters-selected" style="margin-top: 0.75rem;">
                                <div id="selected-vignette-stylesheets"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body full-width">
                        <strong class="form-sub-title no-margin">Code</strong>
                        <div class="form-group">
                            <div class="code-editor-tabs vignettes-edit-options" style="margin-bottom: 10px;">
                                <div class="code-options-wrapper">
                                    <button type="button" class="btn" data-bind="css: { highlight: activeCodeEditor() === 'html' }, event: { click: function() { onClickCodeEditorTab('html') } }">HTML</button>
                                    <button type="button" class="btn" data-bind="css: { highlight: activeCodeEditor() === 'css' }, event: { click: function() { onClickCodeEditorTab('css') } }">CSS</button>
                                    <button type="button" class="btn" data-bind="css: { highlight: activeCodeEditor() === 'js' }, event: { click: function() { onClickCodeEditorTab('js') } }">JS</button>                 
                                </div>
                                <div class="reference-group">
                                    <strong class="form-sub-title no-margin">References</strong>
                                    <table class="list-action vignettes-edit" style="margin: 8px 0 0 0;">
                                    <thead>
                                        <tr>
                                            <th colspan="3" data-bind="event: { click: function() { onClickToggleReferenceSection('tag') } }" style="cursor: pointer;">
                                                <button type="button" class="btn small"><i class="icon i-dropdown-simple" data-bind="css: { 'open': activeReferenceSection() === 'tag', 'closed': activeReferenceSection() !== 'tag' }"></i></button>
                                                <label class="form-label">Tag References</label>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody data-bind="visible: activeReferenceSection() === 'tag'">
                                    <!-- ko foreach: tagDefaults -->
                                        <tr>
                                            <td><label for="" class="form-label" data-bind="text: key"></label></td>
                                            <td><span type="button" data-bind="text: value"></span></td>
                                            <td class="align-right"><button type="button" class="btn border only-icon icon i-copy" title="Copy reference" data-bind="event: { click: $parent.onClickCopyReference }, clickBubble: false"></button></td>
                                        </tr>
                                    <!-- /ko -->
                                    </tbody>
                                    
                                    <thead>
                                        <tr>
                                            <th colspan="3" data-bind="event: { click: function() { onClickToggleReferenceSection('article') } }" style="cursor: pointer;">
                                                <button type="button" class="btn small"><i class="icon i-dropdown-simple" data-bind="css: { 'open': activeReferenceSection() === 'article', 'closed': activeReferenceSection() !== 'article' }"></i></button>
                                                <label class="form-label">Article References</label>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody data-bind="visible: activeReferenceSection() === 'article'">
                                    <!-- ko foreach: articleDefaults -->
                                        <tr>
                                            <td><label for="" class="form-label" data-bind="text: key"></label></td>
                                            <td><span type="button" data-bind="text: value"></span></td>
                                            <td class="align-right"><button type="button" class="btn border only-icon icon i-copy" title="Copy reference" data-bind="event: { click: $parent.onClickCopyReference }, clickBubble: false"></button></td>
                                        </tr>
                                    <!-- /ko -->
                                    </tbody>

                                    <thead>
                                        <tr>
                                            <th colspan="3" data-bind="event: { click: function() { onClickToggleReferenceSection('image') } }" style="cursor: pointer;">
                                                <button type="button" class="btn small"><i class="icon i-dropdown-simple" data-bind="css: { 'open': activeReferenceSection() === 'image', 'closed': activeReferenceSection() !== 'image' }"></i></button>
                                                <label class="form-label">Image References</label>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody data-bind="visible: activeReferenceSection() === 'image'">
                                    <!-- ko foreach: imageDefaults -->
                                        <tr>
                                            <td><label for="" class="form-label" data-bind="text: key"></label></td>
                                            <td><span type="button" data-bind="text: value"></span></td>
                                            <td class="align-right"><button type="button" class="btn border only-icon icon i-copy" title="Copy reference" data-bind="event: { click: $parent.onClickCopyReference }, clickBubble: false"></button></td>
                                        </tr>
                                    <!-- /ko -->
                                    </tbody>

                                    <thead>
                                        <tr>
                                            <th colspan="3" data-bind="event: { click: function() { onClickToggleReferenceSection('video') } }" style="cursor: pointer;">
                                                <button type="button" class="btn small"><i class="icon i-dropdown-simple" data-bind="css: { 'open': activeReferenceSection() === 'video', 'closed': activeReferenceSection() !== 'video' }"></i></button>
                                                <label class="form-label">Video References</label>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody data-bind="visible: activeReferenceSection() === 'video'">
                                    <!-- ko foreach: videoDefaults -->
                                        <tr>
                                            <td><label for="" class="form-label" data-bind="text: key"></label></td>
                                            <td><span type="button" data-bind="text: value"></span></td>
                                            <td class="align-right"><button type="button" class="btn border only-icon icon i-copy" title="Copy reference" data-bind="event: { click: $parent.onClickCopyReference }, clickBubble: false"></button></td>
                                        </tr>
                                    <!-- /ko -->
                                    </tbody>

                                    <thead>
                                        <tr>
                                            <th colspan="3" data-bind="event: { click: function() { onClickToggleReferenceSection('hub') } }" style="cursor: pointer;">
                                                <button type="button" class="btn small"><i class="icon i-dropdown-simple" data-bind="css: { 'open': activeReferenceSection() === 'hub', 'closed': activeReferenceSection() !== 'hub' }"></i></button>
                                                <label class="form-label">Hub References</label>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody data-bind="visible: activeReferenceSection() === 'hub'">
                                    <!-- ko foreach: hubDefaults -->
                                        <tr>
                                            <td><label for="" class="form-label" data-bind="text: key"></label></td>
                                            <td><span type="button" data-bind="text: value"></span></td>
                                            <td class="align-right"><button type="button" class="btn border only-icon icon i-copy" title="Copy reference" data-bind="event: { click: $parent.onClickCopyReference }, clickBubble: false"></button></td>
                                        </tr>
                                    <!-- /ko -->
                                    </tbody>


                                    <thead>
                                        <tr>
                                            <th colspan="3" data-bind="event: { click: function() { onClickToggleReferenceSection('brand') } }" style="cursor: pointer;">
                                                <button type="button" class="btn small"><i class="icon i-dropdown-simple" data-bind="css: { 'open': activeReferenceSection() === 'brand', 'closed': activeReferenceSection() !== 'brand' }"></i></button>
                                                <label class="form-label">Brand References</label>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody data-bind="visible: activeReferenceSection() === 'brand'">
                                    <!-- ko foreach: brandDefaults -->
                                        <tr>
                                            <td><label for="" class="form-label" data-bind="text: key"></label></td>
                                            <td><span type="button" data-bind="text: value"></span></td>
                                            <td class="align-right"><button type="button" class="btn border only-icon icon i-copy" title="Copy reference" data-bind="event: { click: $parent.onClickCopyReference }, clickBubble: false"></button></td>
                                        </tr>
                                    <!-- /ko -->
                                    </tbody>
                                    </table>
                                </div>
                            </div>
                            <div data-bind="visible: activeCodeEditor() === 'html'">
                                <textarea style="height: 300px" id="htmlEditor" data-bind="textInput: html"></textarea>
                                <div id="htmlMonacoEditor" style="height: 300px; border: 1px solid #ddd; display: none;"></div>
                            </div>
                            <div data-bind="visible: activeCodeEditor() === 'css'">
                                <textarea style="height: 300px" id="cssEditor" data-bind="textInput: css"></textarea>
                                <div id="cssMonacoEditor" style="height: 300px; border: 1px solid #ddd; display: none;"></div>
                            </div>
                            <div data-bind="visible: activeCodeEditor() === 'js'">
                                <textarea style="height: 300px" id="jsEditor" data-bind="textInput: js"></textarea>
                                <div id="jsMonacoEditor" style="height: 300px; border: 1px solid #ddd; display: none;"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-form-body">

                    <div class="form-body full-width">
                        <strong class="form-sub-title no-margin">Preview</strong>
                        <div class="form-group">
                            ${ this.vignettePreview.getHtmlBuild() }
                        </div>
                    </div>

                </div>

                <div class="form-footer">
                    <button type="button" data-bind="event: { click: onClickCancel }" class="btn ">Cancel</button>
                    <button type="button" data-bind="event: { click: onClickSave }" class="btn highlight">Save</button>
                    <button type="button" data-bind="event: { click: onClickSaveAndStay }" class="btn highlight">Save & Stay</button>
                </div>
            </div>
            `;
    }

    protected initPartial(): void {

        this.vignettePreviewHelper = new vignettePreview_helper(this.caller.getVnAppZone(), this.caller);
        this.vignettePreview = new vignettePreview_template("vignettePreview", this.getTemplateViewModel(), this.vignettePreviewHelper);
        this.vignettePreview.setShowKeys(true);
        this.vignettePreviewHelper.initializeBrandDefaults();

        this.stylesheetSelector = new multipleSelector_template("stylesheetSelector", this.getTemplateViewModel(), this.caller);
        this.stylesheetSelector.setLabel("Select Stylesheets");
        this.stylesheetSelector.setFilterContainerClass('margin-neg');
        this.stylesheetSelector.setTagContainerId('selected-vignette-stylesheets');
        this.stylesheetSelector.setTagContainerCaption('Selected stylesheets:');
        this.stylesheetSelector.setSearchEnabled(true);
    }

    protected getTemplateName(): string {

        return "vignettesEdit_template";
    }

    protected buildViewModel(): any {

        const self = this;

        return {
            brand: ko.observable(""),
            id: ko.observable(""),
            name: ko.observable(""),
            tagDefaults: ko.observableArray(vignettePreview_template.getTagDefaults()),
            articleDefaults: ko.observableArray(vignettePreview_template.getArticleDefaults()),
            imageDefaults: ko.observableArray(vignettePreview_template.getImageDefaults()),
            videoDefaults: ko.observableArray(vignettePreview_template.getVideoDefaults()),
            hubDefaults: ko.observableArray(vignettePreview_template.getHubDefaults()),
            brandDefaults: ko.observableArray(vignettePreview_template.getBrandDefaults()),
            htmlValue: ko.observable(""),
            html: ko.pureComputed(this.htmlComputed(self)),
            cssValue: ko.observable(""),
            css: ko.pureComputed(this.cssComputed(self)),
            jsValue: ko.observable(""),
            js: ko.pureComputed(this.jsComputed(self)),
            permissions: ko.observableArray(this.initPermissions(['vignettes'])),
            isBrandOwner: ko.pureComputed(() => self.getIsBrandOwner()),
            brandOwner: ko.observable(null),
            idStatus: ko.observable('1'),
            showIsAutosaving: ko.observable(false),
            activeCodeEditor: ko.observable('html'),
            activeReferenceSection: ko.observable(null),
            onClickToggleReferenceSection: this.onClickToggleReferenceSection.bind(this),
            onClickCopyReference: this.onClickCopyReference.bind(this),
            onClickCodeEditorTab: this.onClickCodeEditorTab.bind(this),
            onClickCancel: this.onClickCancel.bind(this),
            onClickSave: this.onClickSave.bind(this),
            onClickSaveAndStay: this.onClickSaveAndStay.bind(this),
            
        }
    }

    public getIsBrandOwner = (): boolean => {
        const vm = this.getTemplateViewModel();

        return (vm.brandOwner() && vm.brand())? vm.brandOwner().id == vm.brand() : false;
    }

    public onClickSave(data, event) {
        this.caller.saveVignette();
    }

    public onClickSaveAndStay(data, event) {
        this.caller.saveVignette('stay');
    }

    public onClickCancel() {
        this.caller.cancel();
    }

    public onClickToggleReferenceSection(section: string): void {
        const vm = this.getTemplateViewModel();
        vm.activeReferenceSection(vm.activeReferenceSection() === section ? null : section);
    }

    public onClickCopyReference(reference): void {
        if (vignettePreview_template.copyReferenceToClipboard(reference)) {
            this.caller.copyToClipboardAlert();
        }
    }

    public onClickCodeEditorTab(editor: string): void {
        const vm = this.getTemplateViewModel();
        vm.activeCodeEditor(editor);
        setTimeout(() => this.layoutMonacoEditor(editor), 0);
    }

    protected htmlComputed(self) {
        return {
            read: function() {
                return self.getTemplateViewModel().htmlValue();
            },
            write: function(value) {
                self.getTemplateViewModel().htmlValue(value);
                self.setMonacoEditorValue('html', value);
                self.vignettePreview.setHtml(value);
            }
        }
    }


    protected cssComputed(self) {
        return {
            read: function() {
                return self.getTemplateViewModel().cssValue();
            },
            write: function(value) {
                self.getTemplateViewModel().cssValue(value);
                self.setMonacoEditorValue('css', value);
                self.updateCombinedPreviewCss();
            }
        }
    }

    protected jsComputed(self) {
        return {
            read: function() {
                return self.getTemplateViewModel().jsValue();
            },
            write: function(value) {
                self.getTemplateViewModel().jsValue(value);
                self.setMonacoEditorValue('js', value);
                self.vignettePreview.setJs(value);
            }
        }
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
    }

    public setVignette(vignette): void {
        this.getTemplateViewModel().id(vignette.id);
        this.getTemplateViewModel().name(vignette.name);
        this.getTemplateViewModel().brandOwner(vignette.brandOwner);
        this.setIdStatus(vignette.idStatus);
        this.setHtml(vignette.html);
        this.setCss(vignette.css);
        this.setJs(vignette.js);
        this.setSelectedStylesheets(vignette.stylesheets || []);
    }

    public getViewModelForRequest() {

        return {
            id: this.getTemplateViewModel().id(),
            name: this.getTemplateViewModel().name(),
            html: this.getTemplateViewModel().html(),
            css: this.getTemplateViewModel().css(),
            js: this.getTemplateViewModel().js(),
            idStatus: this.getIdStatus(),
            stylesheetIds: this.getSelectedStylesheetIds(),
        }
    }

    public setAvailableStylesheets(stylesheets: any[]): void {
        this.availableStylesheets = Array.isArray(stylesheets) ? stylesheets : [];
        const items = this.availableStylesheets.map((stylesheet) => ({
            id: stylesheet.id,
            name: stylesheet.name,
        }));
        this.stylesheetSelector.setItems(items);

        const selectedIds = this.getSelectedStylesheetIds();
        if (selectedIds.length) {
            this.setSelectedStylesheets(selectedIds.map((id) => ({ id })));
        }
        this.updateCombinedPreviewCss();
    }

    public setSelectedStylesheets(stylesheets: any[]): void {
        const selected = (stylesheets || []).map((stylesheet) => {
            if (typeof stylesheet === 'number' || typeof stylesheet === 'string') {
                return { id: Number(stylesheet) };
            }
            return {
                id: Number(stylesheet.id),
                name: stylesheet.name,
                css: stylesheet.css,
                slug: stylesheet.slug,
                idStatus: stylesheet.idStatus,
            };
        }).filter((stylesheet) => stylesheet.id > 0);

        this.selectedStylesheetDetails = selected;
        this.stylesheetSelector.setSelectedItems(selected);
        const selectedIds = selected.map((stylesheet) => stylesheet.id);
        this.stylesheetSelector.setTags(selectedIds, this.stylesheetSelector.getItems());
        this.updateCombinedPreviewCss();
    }

    public getSelectedStylesheetIds(): number[] {
        const selected = this.stylesheetSelector.getSelectedItems() || [];
        return selected.map((item) => Number(item.id || item)).filter((id) => id > 0);
    }

    public getSelectedStylesheetCss(): string {
        const selectedIds = this.getSelectedStylesheetIds();
        if (!selectedIds.length) {
            return '';
        }

        const cssBlocks = [];
        selectedIds.forEach((id) => {
            const fromAvailable = this.availableStylesheets.find((item) => Number(item.id) === id);
            const fromSelected = this.selectedStylesheetDetails.find((item) => Number(item.id) === id);
            const css = (fromAvailable && fromAvailable.css) || (fromSelected && fromSelected.css) || '';
            if (css) {
                cssBlocks.push(css);
            }
        });
        return cssBlocks.join('\n\n');
    }

    public updateCombinedPreviewCss(): void {
        const sharedCss = this.getSelectedStylesheetCss();
        const vignetteCss = this.getTemplateViewModel().cssValue() || '';
        const combined = [sharedCss, vignetteCss].filter((block) => !!block && block.trim() !== '').join('\n\n');
        this.vignettePreview.setCss(combined);
    }

    public setHtml(value): void {
        this.getTemplateViewModel().html(value);
    }

    public setId(value): void {
        this.getTemplateViewModel().id(value);
    }

    public getId() {
        return this.getTemplateViewModel().id();
    }

    public setName(value): void {
        this.getTemplateViewModel().name(value);
    }

    public getName() {
        return this.getTemplateViewModel().name();
    }

    public setIdStatus(value): void {
        this.getTemplateViewModel().idStatus(String(value || '1'));
    }

    public getIdStatus(): number {
        return Number(this.getTemplateViewModel().idStatus());
    }

    public setIsAutosaving(value): void {
        this.getTemplateViewModel().showIsAutosaving(value);
    }

    public setCss(value): void {
        this.getTemplateViewModel().cssValue(value || '');
        this.setMonacoEditorValue('css', value || '');
        this.updateCombinedPreviewCss();
    }

    public setJs(value): void {
        this.getTemplateViewModel().js(value);
    }

    public setBrand(brand): void {

      this.getTemplateViewModel().brand(brand);
    }

    public setBrandDefaults(brandReferences: any, labels: any): void {
        this.getTemplateViewModel().brandDefaults(vignettePreview_template.formatBrandReferences(brandReferences, labels));
    }

    public setupMonacoEditors(): void {
        setTimeout(() => {
            this.loadMonacoEditor().then((monaco) => {
                this.createMonacoEditor(monaco, 'html', 'html', 'htmlEditor', 'htmlMonacoEditor');
                this.createMonacoEditor(monaco, 'css', 'css', 'cssEditor', 'cssMonacoEditor');
                this.createMonacoEditor(monaco, 'js', 'javascript', 'jsEditor', 'jsMonacoEditor');
                this.layoutMonacoEditor(this.getTemplateViewModel().activeCodeEditor());
            }).catch(() => {
                this.showFallbackCodeEditors();
            });
        }, 0);
    }

    protected loadMonacoEditor(): any {
        const win: any = window as any;
        if (win.monaco && win.monaco.editor) {
            return Promise.resolve(win.monaco);
        }
        if (this.monacoLoaderPromise) {
            return this.monacoLoaderPromise;
        }

        this.monacoLoaderPromise = new Promise((resolve, reject) => {
            const configureLoader = () => {
                if (!win.require || typeof win.require.config !== 'function') {
                    reject();
                    return;
                }
                win.require.config({ paths: { vs: '/node_modules/monaco-editor/min/vs' } });
                win.require(['vs/editor/editor.main'], () => {
                    resolve(win.monaco);
                });
            };

            if (win.require && typeof win.require.config === 'function') {
                configureLoader();
                return;
            }

            const existingScript = document.querySelector('script[data-monaco-loader="true"]') as HTMLScriptElement;
            if (existingScript) {
                existingScript.addEventListener('load', configureLoader);
                existingScript.addEventListener('error', reject);
                return;
            }

            const script = document.createElement('script');
            script.src = '/node_modules/monaco-editor/min/vs/loader.js';
            script.setAttribute('data-monaco-loader', 'true');
            script.addEventListener('load', configureLoader);
            script.addEventListener('error', reject);
            document.body.appendChild(script);
        });

        return this.monacoLoaderPromise;
    }

    protected createMonacoEditor(monaco: any, key: string, language: string, textareaId: string, containerId: string): void {
        if (this.monacoEditors[key]) {
            this.setMonacoEditorValue(key, this.getTemplateViewModel()[key]());
            this.layoutMonacoEditor(key);
            return;
        }

        const textarea = document.getElementById(textareaId) as HTMLElement;
        const container = document.getElementById(containerId) as HTMLElement;
        if (!textarea || !container) {
            return;
        }

        textarea.style.display = 'none';
        container.style.display = 'block';

        const editor = monaco.editor.create(container, {
            value: this.getTemplateViewModel()[key](),
            language: language,
            theme: 'vs-dark',
            lineNumbers: 'on',
            automaticLayout: true,
            minimap: { enabled: false },
            scrollBeyondLastLine: false,
            wordWrap: 'on',
            formatOnPaste: true,
            formatOnType: true,
        });

        editor.onDidChangeModelContent(() => {
            const value = editor.getValue();
            if (this.getTemplateViewModel()[key]() !== value) {
                this.getTemplateViewModel()[key](value);
            }
        });

        editor.onDidFocusEditorText(() => {
            if (this.caller && typeof this.caller.startAutosave === 'function') {
                this.caller.startAutosave();
            }
        });

        this.monacoEditors[key] = editor;
    }

    public setRecoveryContent(content): void {
        if (typeof content.name !== 'undefined') {
            this.setName(content.name);
        }
        if (typeof content.idStatus !== 'undefined') {
            this.setIdStatus(content.idStatus);
        }
        if (typeof content.html !== 'undefined') {
            this.setHtml(content.html);
        }
        if (typeof content.css !== 'undefined') {
            this.setCss(content.css);
        }
        if (typeof content.js !== 'undefined') {
            this.setJs(content.js);
        }
        if (typeof content.stylesheetIds !== 'undefined') {
            this.setSelectedStylesheets(content.stylesheetIds);
        } else if (typeof content.stylesheets !== 'undefined') {
            this.setSelectedStylesheets(content.stylesheets);
        }
    }

    protected setMonacoEditorValue(key: string, value: string): void {
        const editor = this.monacoEditors[key];
        if (editor && editor.getValue() !== (value || '')) {
            editor.setValue(value || '');
        }
    }

    protected layoutMonacoEditor(key: string): void {
        const editor = this.monacoEditors[key];
        if (editor) {
            editor.layout();
        }
    }

    protected showFallbackCodeEditors(): void {
        ['html', 'css', 'js'].forEach((key) => {
            const textarea = document.getElementById(`${key}Editor`) as HTMLElement;
            const container = document.getElementById(`${key}MonacoEditor`) as HTMLElement;
            if (textarea) {
                textarea.style.display = 'block';
                textarea.addEventListener('focus', () => {
                    if (this.caller && typeof this.caller.startAutosave === 'function') {
                        this.caller.startAutosave();
                    }
                });
            }
            if (container) {
                container.style.display = 'none';
            }
        });
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/vignettesEdit_template.ts